
import { CommunicationRenseignement } from "../../model/CommunicationRenseignement";

export const initialState: CommunicationRenseignement = {
    statut: null,
    nom: "",
    prenom: "",
    courriel: "",
    adresse: "",
    ville: "",
    provinceOuTerritoire: "",
    codePostal: "",
    employeur: "",
    fonction: "",
    telephone1: "",
    telephone2: "",
    telephone1ModeContactPrivilegie: false,
    telephone2ModeContactPrivilegie: false,
    courrielModeContactPrivilegie: false,
    francais: false,
    anglais: false,
    autreLangue: "",
    organismesConcernes: "",
    entreprisesConcernees: "",
    personnesConcernees: "",
    renseignements: "",
    numeroAppelOffreContratAvisIntention: "",
    renseignementsTransmisAutreOrganisme: null,
    autreOrganisme: "",
    dateTransmissionAutreOrganisme: null,
    attestation: false
}